const BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:3005' 
  : 'https://colorfuel-api-production.up.railway.app';

export const API_CONFIG = {
  BASE_URL,
  AUTH_LOGIN: '/api/auth/login',
  AUTH_REFRESH: '/api/auth/refresh-token',
  // OpenSea API endpoints
  OPENSEA_NFTS: '/api/opensea/selected-collections/nfts',
  OPENSEA_OFFERS: '/api/opensea/orders/ethereum/seaport/offers',
  OPENSEA_ACCOUNT_NFTS: '/api/opensea/chain',
  OPENSEA_NFT_OWNER: '/api/opensea/nft/owner',
  OPENSEA_OFFER_SUBMIT: '/api/opensea/nft/offer/submit',
  // Helius API endpoints
  HELIUS_BALANCE: '/api/helius/balance',
  HELIUS_NFTS: '/api/helius/owner',
  HELIUS_COLLECTIONS: '/api/helius/owner'
};

// Default credentials for auto-login (can be overridden via environment variables)
export const DEFAULT_CREDENTIALS = {
  username: process.env.REACT_APP_API_USERNAME || 'test123',
  password: process.env.REACT_APP_API_PASSWORD || 'testtesttest123'
};
